import React, { useEffect } from 'react';
import { getEnvFromUrl } from '../helpers/getEnv';
import {
  DYNATRACE_SESSION_KEY,
  DYNATRACE_SESSION_VALUE,
  ISSUER_SESSION_KEY,
  JVCEF,
  VRPAT,
} from '../config/constants';
import { Loader } from '~/components';

function AutoSelectIssuer() {
  useEffect(() => {
    const { hash } = window.location;
    const { isDynatrace } = getEnvFromUrl();

    if (isDynatrace) {
      sessionStorage.setItem(DYNATRACE_SESSION_KEY, DYNATRACE_SESSION_VALUE);
    }

    let sessionIssuer = VRPAT;

    if (hash.includes('caixa')) {
      sessionIssuer = JVCEF;
    }

    sessionStorage.setItem(ISSUER_SESSION_KEY, sessionIssuer);

    window.location.href = '/';
  }, []);

  return (
    <Loader isLoading>
      <div style={{ height: '80vh' }} />
    </Loader>
  );
}

export default AutoSelectIssuer;
